module.exports = __webpack_public_path__ + "img/onboarding-step4.e09ac50d.svg";